import { render, staticRenderFns } from "./PessoaInterfaceForm.vue?vue&type=template&id=fafc1b3e"
import script from "./PessoaInterfaceForm.vue?vue&type=script&lang=js"
export * from "./PessoaInterfaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports